export const DEFAULT_THEME_COLOR = '#0d6e8a';

export const themeColorPresets = [
  { id: 'teal', label: 'Teal', color: '#176b5b' },
  { id: 'ocean', label: 'Ocean', color: '#0d6e8a' },
  { id: 'forest', label: 'Forest', color: '#2e7d4f' },
  { id: 'navy', label: 'Navy', color: '#1e3a5f' },
  { id: 'slate', label: 'Slate', color: '#455a64' },
  { id: 'blue', label: 'Blue', color: '#1565c0' },
  { id: 'amber', label: 'Amber', color: '#b7791f' },
  { id: 'crimson', label: 'Crimson', color: '#9b2c2c' }
];

export function normalizeThemeColor(value) {
  const color = String(value || '').trim().toLowerCase();
  if (!/^#[0-9a-f]{6}$/.test(color)) return DEFAULT_THEME_COLOR;
  return color;
}

export function lightenHex(hex, amount = 0.28) {
  const normalized = normalizeThemeColor(hex).slice(1);
  const channels = [0, 2, 4].map((index) => Number.parseInt(normalized.slice(index, index + 2), 16));
  return `#${channels
    .map((channel) => Math.round(channel + (255 - channel) * amount).toString(16).padStart(2, '0'))
    .join('')}`;
}
